import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://9f923ad726233a004f90f238cd8b5cb0@o4508919758454784.ingest.us.sentry.io/4508923385020416',
  enabled: import.meta.env.MODE !== 'development',
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        'https://api.floppydata.com/v1/pools/generate-proxies',
        'https://api.floppydata.com/v1/*',
        'https://fdapi777.alex-0da.workers.dev/*',
      ],
      networkRequestHeaders: ['X-Custom-Header'],
      networkResponseHeaders: ['X-Custom-Header'],
    }),
    Sentry.browserTracingIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/fdapi777.alex-0da.workers.\.dev/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
